<template>
  <v-container fluid>
    <create-shop-drawer :dialog="drawer" @close="drawer=false" @save="onShopCreated"></create-shop-drawer>
    <v-layout class="mb-4">
      <v-flex xs6 md6>
        <h3 class="title font-weight-bold pl-2">ร้านค้า ({{total}})</h3>
      </v-flex>
      <v-flex xs6 md6 class="text-xs-right">
        <el-button v-if="canCreate" @click="drawer=true" type="danger" size="small">สร้างร้านค้าใหม่</el-button>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <div class="px-1 pt-2">
          <el-checkbox-group v-model="statusFiltered" @change="onStatusFilteredChanged()">
            <el-checkbox
              v-for="item in shopStatusList"
              :key="item.value"
              :label="item.value"
            >{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </v-flex>
    </v-layout>
    <el-card>
      <v-data-table
        :headers="headers"
        :items="results"
        :pagination.sync="pagination"
        :loading="isLoading"
        class="elevation-0"
      >
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center">
              <span class="grey--text">{{props.item.ref_no}}-</span>
              {{props.item.shop_id | numFormat('00000')}}
              <div>
                <div v-if="props.item.status=='draft'" class="grey badge-status">ยังไม่สมบูรณ์</div>
                <div v-if="props.item.status=='inactive'" class="red badge-status">เลิกกิจการ</div>
                <div v-if="props.item.status=='temp_close'" class="orange badge-status">ปิดชั่วคราว</div>
                <div v-if="props.item.status=='published'" class="green badge-status">เปิดบริการอยู่</div>
              </div>
            </td>
            <td>
              <div style="width:110px;" class="my-2">
                <el-select
                  v-model="props.item.status"
                  placeholder="Select"
                  :size="`mini`"
                  @change="onUpdateStatus(props.item)"
                >
                  <el-option
                    v-for="item in shopStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </td>
            <td style="position:relative;" class="py-3">
              <div
                class="pic"
                v-bind:style="{ 'background-image': 'url(' + props.item.logo_url + ')' }"
              ></div>
              <div style="padding-left:60px;">
                <div style="width:220px;">
                  <div class="line-1-elipsis">
                    <strong>{{props.item.name}}</strong>
                  </div>
                  <div class="grey--text line-1-elipsis">{{props.item.excerpt}}</div>
                </div>
              </div>
            </td>
            <td class="py-3">
              <div style="width:110px;" class="my-2">
                <el-select
                  v-model="props.item.rank"
                  placeholder="Select"
                  :size="`mini`"
                  @change="onUpdateStatus(props.item)"
                >
                  <el-option
                    v-for="item in rankList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </td>
            <td class="text-xs-right">
              <div style="width:180px;">
                <el-button
                  type="text"
                  size="small"
                  class="mr-2"
                  @click="openItem(props.item)"
                >ดูรายละเอียด</el-button>
                <el-button
                  class="grey--text darken-2"
                  type="text"
                  size="small"
                  @click="openLink(props.item)"
                >
                  <i class="fas fa-link"></i> ลิงก์
                </el-button>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </el-card>
    <link-dialog :links="links" :showDialog="linkDialog" @close="onLinkDialogClosed"></link-dialog>
  </v-container>
</template>
<script>
import Service from "../../services";

import CreateShopDrawer from "../../components/CreateShopDrawer";
import LinkDialog from "../../components/LinkDialog";

import { mapState } from "vuex";

export default {
  components: {
    CreateShopDrawer,
    LinkDialog
  },
  computed: {
    statusFiltered: {
      get() {
        return this.$store.state.Util.shopStatusFiltered;
      },
      set(value) {
        this.$store.dispatch("Util/setShopStatusFiltered", value);
      }
    }
  },
  data() {
    return {
      mode: "admin",
      isLoading: true,
      list: [],
      results: [],
      total: 0,
      pagination: {
        rowsPerPage: -1
      },
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: ""
        },
        { text: "สถานะ", value: "", sortable: false },
        { text: "ชื่อร้าน", value: "", sortable: false },
        { text: "การจัดลำดับ", value: "", sortable: false },
        { text: "", value: "", sortable: false }
      ],
      statusOrder: ["temp_close", "published", "draft", "inactive"],
      shopStatusList: [
        { label: "ปิดชั่วคราว", value: "temp_close" },
        { label: "เปิดบริการอยู่", value: "published" },
        { label: "ยังไม่สมบูรณ์", value: "draft" },
        { label: "เลิกกิจการ", value: "inactive" }
      ],
      rankList: [
        { label: "แสดงผลก่อน", value: 10 },
        { label: "แสดงผลปกติ", value: 9999 }
      ],
      drawer: false,
      permission: null,
      canCreate: false,
      links: null,
      linkDialog: false
    };
  },
  created() {
    this.loadList();

    Service.User.permission().then(resp => {
      this.permission = resp.data;
      if (
        this.permission.user.role_id == "super_admin" ||
        this.permission.enterprises[0].ent_type == "platform"
      ) {
        this.canCreate = true;
      }
      if (this.permission.user.role_id == "enterprise_manager") {
        this.mode = "enterprise_manager";
      }
    });
  },
  methods: {
    loadList() {
      Service.Shop.gets().then(res => {
        if (res.success) {
          this.list = res.data;
          this.total = this.list.length;
          this.list.sort(
            (a, b) =>
              this.statusOrder.indexOf(a.status) -
              this.statusOrder.indexOf(b.status)
          );
          this.onStatusFilteredChanged();
          //this.results = this.list;
        }
        this.isLoading = false;
      });
    },
    openItem(item) {
      this.$router.push("/view/shop/" + item.ref_no);
    },
    openLink(item) {
      Service.Shop.getLink(item.ref_no).then(res => {
        this.links = res.data;
        this.linkDialog = true;
      });
    },
    onLinkDialogClosed() {
      this.links = null;
      this.linkDialog = false;
    },
    onShopCreated() {
      this.loadList();
      this.drawer = false;
    },
    onUpdateStatus(item) {
      let data = {
        ref_no: item.ref_no,
        shop_status: item.status,
        rank: item.rank
      };
      Service.Shop.update(data).then(res => {});
    },
    onStatusFilteredChanged() {
      this.results = this.list.filter(x =>
        this.statusFiltered.includes(x.status)
      );
    }
  }
};
</script>
<style scoped>
.v-chip .v-chip__content {
  text-align: center;
}

.shop-cover {
  width: 60px;
  height: 60px;
  margin: 15px 8px;
  background-size: cover;
  background-position: center;
  float: left;
}

.pic {
  width: 50px;
  height: 50px;
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  background-size: cover;
}
</style>